import { render, staticRenderFns } from "./EmployerTrainingRoot.vue?vue&type=template&id=67b7ed65&"
import script from "./EmployerTrainingRoot.vue?vue&type=script&lang=js&"
export * from "./EmployerTrainingRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports